import moment from "moment";

export function formatDate(d) {
  if (!d) return ""; // Protection against null/undefined
  return moment(d, ["DD.MM.YYYY", moment.ISO_8601]).format("DD.MM.YYYY");
}

export function formatMonth(d) {
  return moment(d).format("MMM - YYYY");
}

export function formatDateWithMonth(d) {
  if (!d) return ""; // Protection against null/undefined
  return moment(d).format("DD MMM YYYY");
}

export function formatTime(d) {
  return moment(d).format("HH:mm");
}

export function formatDateForServer(d) {
  return moment(d).format("YYYY-MM-DD");
}

export function formatDateForInvoice(d) {
  if (!d) return "";
  return moment(d).format("DD.MM.YYYY");
}

export function formatDateForHistory(d) {
  if (!d) return "";
  return moment(d).format("DD/MM/YYYY hh:mm");
}

export function formatDateTime24(d) {
  if (!d) return "";
  return moment(d, ["DD.MM.YYYY", moment.ISO_8601]).format("DD.MM.YYYY HH:mm");
}